import { GetServerSideProps } from 'next';
import { Params } from 'next/dist/server/router';
import Router from 'next/router';
import { useEffect } from 'react';

import { courseTitleBrowser } from '@common/constant/courseConstant';
import { ROUTES } from '@common/constant/routeConstant';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import courseAPI from 'src/api/course';
import Seo from 'src/components/atoms/seo';
import CourseCpdDetail from 'src/components/templates/coursesCpdDetail';
import Main from 'src/components/templates/main';
import { getCourseUrl } from 'src/helpers/utils';
import { ICourse } from 'src/interfaces';
import { SWRConfig } from 'swr';

import { setAffiliateCookie } from '@helpers/cookieUtils';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale, params } = context as Params;
  const idName = params?.idName;
  const responseCourse = await courseAPI.fetchCourse(encodeURIComponent(idName as string));

  if (responseCourse.status === 404) {
    return {
      notFound: true,
    };
  }

  const course: ICourse = responseCourse.data;

  if (course.product.isCpd && course.product.redirect_url) {
    return {
      redirect: {
        destination: course.product.redirect_url,
        permanent: false,
      },
    };
  }

  return {
    props: {
      fallback: {
        COURSE: course || {},
        status: responseCourse.status,
      },
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

const CourseCpd = ({ fallback }: any) => {
  useEffect(() => {
    const course: ICourse = fallback.COURSE;
    const isCpd = course.product?.isCpd;
    if (fallback.status === 404) {
      Router.push('/not-found');
      return;
    }
    if (fallback.status === 500) {
      throw new Error('cannot get course');
    } else if (!isCpd) {
      Router.push(getCourseUrl(course));
      return;
    }
    setAffiliateCookie();
  }, [fallback]);

  if (fallback.status !== 200) {
    return null;
  }

  return (
    <SWRConfig value={{ fallback }}>
      <Main scrollToTop hideHeaderOnScroll scrollBottomDesktop={170} scrollBottomMobile={100} hideDownloadApp>
        <Seo
          title={courseTitleBrowser(fallback.COURSE?.name)}
          description={fallback.COURSE.fb_content}
          image_url={fallback.COURSE.share_thumbnail_image}
        />
        <CourseCpdDetail />
      </Main>
    </SWRConfig>
  );
};

export default CourseCpd;
